import { GOMap, GoIOTLayer } from "@goaigua/go-gisapi";
import {
    addLayerToGisHierarchyItem,
    createGisHierarchyItem,
    getAllGisHierarchyItemsByHierarchyId,
} from "services/requests/v1/gishierarchyitem";
import {
    GisLayerTableType,
    GoAiguaSelectOption,
    HierarchyItemType,
} from "types/generic";

export const setLayerOnMap = async (
    map: GOMap,
    layer: GisLayerTableType[] | undefined,
    layers: any[]
) => {
    layers.forEach((layerTable) => {
        const selectedLayer = map
            .getMap("marker")
            ?.getLayers()
            .getArray()
            .find((layer) => layer.getProperties().id === layerTable.id);

        if (selectedLayer) {
            try {
                if (
                    layer &&
                    layer.some((layerId) => {
                        return layerId.id.toString() === layerTable.id;
                    })
                ) {
                    selectedLayer.setVisible(true);
                    if (selectedLayer.getProperties().type === "GoIOTLayer") {
                        const layerAux = map
                            .getStaging("marker")
                            ?.getLayer(layerTable.id);
                        layerAux.iconLayer.setVisible(true);
                    }
                } else {
                    selectedLayer.setVisible(false);
                    if (selectedLayer.getProperties().type === "GoIOTLayer") {
                        const layerAux = map
                            .getStaging("marker")
                            ?.getLayer(layerTable.id);
                        layerAux.iconLayer.setVisible(false);
                    }
                }
            } catch {
                if (
                    layer &&
                    layer.some(
                        (layerId) => layerId.id.toString() === layerTable.id
                    )
                ) {
                    (selectedLayer as any).values_.visible = true;
                } else {
                    (selectedLayer as any).values_.visible = false;
                }
            }
        }
    });
};

export const jumpToBlankPage = (url: string): void => {
    window.open(`${url}`, "_blank");
};

export const switchTheme = (theme: "light" | "dark" | "mm") => {
    // Set the page theme on <html> tag.
    document.documentElement.setAttribute("theme", theme);
};

export const refreshPage = (): void => {
    window.location.reload();
};
export const isTokenKCApiExpired = (token: any) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split("")
            .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
    );

    const { iat } = JSON.parse(jsonPayload);
    // 5 min from generation
    const expired = Date.now() >= (iat + 5 * 60) * 1000;
    return expired;
};

export const formatUnitSymbol = (unformattedSymbol: string) => {
    return unformattedSymbol.replace(/2/, "\xB2").replace(/3/, "\xB3");
};

type NodeType = "group" | "layer";

export const checkIsSaveButtonActive = (
    selectedNodeType: NodeType,
    newNodeName: string,
    selectedOption: GoAiguaSelectOption
) => {
    if (selectedNodeType === "group") {
        return newNodeName ? "enabled" : "disabled";
    } else {
        return selectedOption.value !== "" ? "enabled" : "disabled";
    }
};

export const getHierarchyFilter = (
    hierarchy: HierarchyItemType[],
    hierarchyAux: HierarchyItemType[],
    node: HierarchyItemType
) => {
    const parentNode = hierarchy.find((child) => child.id === node.parent);
    if (parentNode) {
        const parentNodeIdAux = hierarchyAux.findIndex(
            (child) => child.id === parentNode.id
        );
        if (parentNodeIdAux === -1) {
            hierarchyAux.push(parentNode);
            getHierarchyFilter(hierarchy, hierarchyAux, parentNode);
        }
    }
};

export const getHierarchyLayers = (
    hierarchy: HierarchyItemType[],
    hierarchyAux: HierarchyItemType[],
    node: HierarchyItemType
) => {
    const parentNode = hierarchy.filter((child) => child.parent === node.id);

    parentNode.forEach((ev) => {
        if (parentNode) {
            const parentNodeIdAux = hierarchyAux.findIndex(
                (child) => child.id === ev.id
            );
            if (parentNodeIdAux === -1) {
                hierarchyAux.push(ev);
                node = { ...node, selected: true };
                getHierarchyLayers(hierarchy, hierarchyAux, ev);
            }
        }
    });
};

export const makeDebounceFunction = () => {
    let timerID: NodeJS.Timeout;

    return (callBack: Function, timeMS = 300) => {
        if (timerID) clearTimeout(timerID);
        timerID = setTimeout(() => callBack(), timeMS);
    };
};

export const makeDeepCopy = <T>(data: T): T => {
    return JSON.parse(JSON.stringify(data));
};
